import {FiltersBar} from '@/components/ui/filters-bar/FiltersBar'
import {InputSelectLastYearMonth} from '../input-select-last-year-month/InputSelectLastYearMonth'
import {useTranslation} from '@/translations/i18n'
import {AccessesValidatorUserFilter} from '../accesses-validator-user-filter/AccessesValidatorUserFilter'
import {AccessesValidatorPatientFilter} from '../accesses-validator-patient-filter/AccessesValidatorPatientFilter'
import {StyledFiltersGrid} from './style'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {ValidatorSearchParams} from '../../types'
import dayjs from 'dayjs'
import {formatDate} from '@/dayjs'
import {useAccessesAccordion} from '../accesses-accordion-context-provider/AccessesAccordionContextProvider'

export const AccessesValidatorsFilters = () => {
    const {t} = useTranslation()
    const {searchParams, setSearchParams} = useParsedSearchParams(ValidatorSearchParams)
    const {collapseAll} = useAccessesAccordion()

    const onChangeMonth = (value: string) => {
        setSearchParams({
            startDate: formatDate(dayjs(value).startOf('month').toString(), 'YYYY-MM-DD'),
            endDate: value
        })
        collapseAll()
    }

    return (
        <FiltersBar>
            <StyledFiltersGrid>
                <AccessesValidatorUserFilter />

                <InputSelectLastYearMonth
                    disabled={!searchParams.consultant}
                    label={t('accesses:period')}
                    value={searchParams.endDate}
                    onChange={onChangeMonth}
                />
                <AccessesValidatorPatientFilter disabled={!searchParams.consultant} />
            </StyledFiltersGrid>
        </FiltersBar>
    )
}
